// extracted by mini-css-extract-plugin
export default {"personalOffice":"PersonalOfficeColumns_personalOffice--c6R","column":"PersonalOfficeColumns_column--jR_","sidebarColumn":"PersonalOfficeColumns_sidebarColumn--jAT"};